<template>
  <div>
    <Header />
    <div class="columns">
      <div class="column is-nav is-narrow-tablet is-12-mobile">
        <Menu />
      </div>
      <div class="column">
        <main class="main-content">
          <router-view />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from './components/Header.vue'
  import Menu from './components/Menu.vue'

  export default {
    name: 'app',
    components: {
      Header,
      Menu
    }
  }
</script>
